<template>
    <div class="d-flex align-items-center h-100">
        <multiselect v-model="active"
                     :deselect-label="$t('UI.cantRemove')"
                     track-by="id"
                     :custom-label="customLabel"
                     :max-height="600"
                     :style="{'font-size': '12px'}"
                     :multiple="multiple"
                     :option-height="31"
                     :closeOnSelect="true"
                     placeholder="Select shop"
                     id="shop"
                     :preserve-search="true"
                     :options="dataShopList"
                     :searchable="true"
                     :allow-empty="true"
                     v-if="dataShopList">
                <template slot="option" slot-scope="props">
                    <div class="box" v-if="props && props.option">
                        <div class="icon">
                            <img :src="props.option.iconURL">
                        </div>
                        <div class="content">
                            <div class="name">
                                {{props.option.name}}
                                <strong v-if="props.option.externalID">{{props.option.externalID}}</strong>
                            </div>
                            <div class="address" v-if="props.option.address">
                                <small><strong>Coutry: </strong>{{props.option.address.country}}</small>
                                <small><strong>City: </strong>{{props.option.address.city}} {{props.option.address.postcode}}</small>
                                <small><strong>Street: </strong>{{props.option.address.street}} {{props.option.address.houseNumber}}</small>
                            </div>
                        </div>
                    </div>
                </template>

                <template slot="tag" slot-scope="props">
                  <div class="box-tag" v-if="props && props.option">
                      <div class="icon">
                          <img :src="props.option.iconURL">
                      </div>
                      <div class="content">
                          <div class="name">
                              {{props.option.name}}
                              <strong v-if="props.option.externalID">{{props.option.externalID}}</strong>
                          </div>
                          <div class="address" v-if="props.option.address">
                              <small>{{props.option.address.country}} </small>
                              <small>{{props.option.address.city}} {{props.option.address.postcode}} </small>
                              <small>{{props.option.address.street}} {{props.option.address.houseNumber}} </small>
                          </div>
                      </div>
                  </div>
                </template>
        </multiselect>
        <span v-else>{{$t('COMMON.noShopsAssigned')}}</span>
        <div class="clear"> <button :disabled="!shop" class="btn btn-sm btn-warning" @click="clear">Clear</button> </div>
    </div>
</template>

<script type="text/babel">
import {mapGetters} from 'vuex';

export default {
    name: 'ShopPicker',
    data () {
        return {};
    },
    props: {
        shop: undefined,
        multiple:{
          type: Boolean,
          default(){
            return false;
          }
        },
        shops: {
          type: Array
        }
    },
    watch: {
      shop: function (val) {
        if(!val){
          this.$store.dispatch('SetActiveShopAction', '');
        } else {
          this.active = val;
        }
      }
    },
    computed: {
        ...mapGetters({
            activeShop : 'getActiveShop',
            shopList: 'getShopList'
        }),
        active: {
            get () {
                return this.activeShop;
            },
            set (shop) {
                this.$emit('update:shop', shop);
                this.$store.dispatch('SetActiveShopAction', shop);
            }
        },
        dataShopList (){
          if(this.shops){
            return this.shops;
          }
          return this.shopList;
        }
    },
    methods: {
        clear () {
          this.shop = undefined;
          this.$emit('update:shop', undefined);
          this.$store.dispatch('SetActiveShopAction', undefined);
        },
        customLabel ({name = '', address = {}, externalID = ''}) {
            const { country, city, street, postcode, houseNumber } = address;
            return `${name} - ${externalID} - ${country} - ${city} - ${street} - ${postcode} - ${houseNumber}`;
        }
    },
    destroyed(){
        this.$store.dispatch('SetActiveShopAction', '');
    },
    mounted(){
      if(this.shop){
        this.active = this.shop;
      }
    }
};

</script>

<style lang="scss" scoped>

  /deep/ {
    input::-webkit-input-placeholder {
        color: lightgray;
    }

   .multiselect,
   .multiselect__input,
   .multiselect__single {
     font-size: 13px;
   }

   .multiselect__tag{
     background: #729fcc;
     margin-bottom: 0;
     padding-top: 3px;
     padding-bottom: 3px;
     border-radius: 2px;
     display: inline;
   }

   .multiselect__tags,
   .multiselect__single {
      border-radius: .2rem;
      border-color: #ced4da;
      padding-top: 0;
      font-size: 13px;
      min-height: 31px;
      line-height: 31px;
    }

    .multiselect{
      &.multiselect--active{
        .multiselect__tags, .multiselect__single{
          border-color: #8ca3f1;
        }
      }
    }

    .multiselect__input,
    .multiselect__single,
    .multiselect__placeholder{
      min-height: 31px;
      margin-bottom: 0;
      padding-top: 0;
      line-height: 31px;

    }

    .multiselect__select{
      height: 31px;
    }

    .multiselect__input,
    .multiselect__placeholder{
      color: lightgray;
    }
  }

  .invalid.dirty {
      & /deep/ .multiselect__tags {
          border-color: red;
      }
      & /deep/ .multiselect__input::-webkit-input-placeholder {
          color: lightgray;
      }
  }
  .box{
      display: flex;
      .icon{
          width: 40px;
          img{
              max-width: 40px;
              height: auto;
          }
          display: inline-block;
          margin-right: 5px;
      }
      .content{
          display: inline-block;
      }
      small{
          display: block;
      }
  }
  .box-tag{
      display: flex;
      background-color: #ced4da;
      padding-left: 3px;
      margin-bottom: 3px;
      .icon{
          width: 10px;
          img{
              max-width: 10px;
              height: auto;
          }
          display: inline-block;
          margin-right: 5px;
      }
      .content{
          display: inline-block;
          .address, .name{
            display: inline-block;
          }
          .address{
            margin-left: 5px;
          }
      }
  }

  .clear{
    padding-bottom: 2px;
    max-height: 40px;
    button{
      margin-bottom: 6px;
      margin-left: 2px;
    }
  }
</style>
